/*
 * @author:
 * @Date: 2021-10-22 15:20:00
 * @LastEditTime: 2023-02-09 13:20:31
 * @FilePath: \场外----客户\src\store\getters.js
 */
const getters = {
  custId: state => state.cust.custId,
  custName: state => state.cust.custName,
  sessionKey: state => state.cust.sessionKey,
  ruleList: state => state.rule.ruleList,
  showDelta: state => state.stats.showDelta,
  managerSessionKey: state => state.manager.sessionKey,
  managerName: state => state.manager.name,
  phoneNumber: state => state.cust.phoneNumber,
  role: state => state.cust.role,
  masterCanOrder: state => state.cust.masterCanOrder,
  queryInfo: state => state.automaticOrder.queryInfo,
  inquiryInfo: state => state.automaticOrder.inquiryInfo,
  orderInfo: state => state.automaticOrder.orderInfo,
  isHeaderShow: state => state.automaticOrder.isHeaderShow,
  isLoading: state => state.automaticOrder.isLoading,
  tradingdateList: state => state.automaticOrder.tradingdateList,
  selectExchange: state => state.automaticOrder.selectExchange,
  selectedFutu: state => state.automaticOrder.selectedFutu,
  queryLists: state => state.automaticOrder.queryLists,
  isListPageShow: state => state.automaticOrder.isListPageShow,
  futuList: state => state.automaticOrder.futuList,
  productIdList: state => state.automaticOrder.productIdList,
  isClear: state => state.automaticOrder.isClear,
  exercisePrice: state => state.automaticOrder.exercisePrice,
  // 客户类型
  custType: state => state.cust.custType,
  // 当前页面权限,暂时根据登陆页面来判断
  istradeCustLogin: state => state.rule.istradeCustLogin
}
export default getters
